import dayjs from "dayjs";
import {
  EventAvailabilityDetails,
  EventDetails,
  EventStatus,
  EventType,
} from "features/types";

export const formatEventDate = (
  event: EventDetails | EventAvailabilityDetails,
  format?: string
): string => {
  let eventStatus: EventStatus;

  if (event.hasOwnProperty("status")) {
    eventStatus = (event as EventDetails).status;
  } else {
    eventStatus = (event as EventAvailabilityDetails).eventStatus;
  }
  if (eventStatus !== "NORMAL") {
    return eventStatus;
  }

  let predefinedFormat = "";
  if (event.containsTime === false) {
    predefinedFormat = "ddd, MMM D";
  } else {
    predefinedFormat = "ddd, MMM D - h:mm a";
  }
  return dayjs(event.localDate)
    .tz(event.timezone)
    .format(format || predefinedFormat);
};

export const isParkingEvent = (
  event: EventDetails | EventAvailabilityDetails
) => {
  if ("eventId" in event) {
    return (event as EventAvailabilityDetails).eventType === "PARKING";
  }
  return (event as EventDetails).type === "PARKING";
};

export const SPORT_EVENT_TYPES: { [key: string]: string } = {
  BASEBALL: "Baseball",
  BASKETBALL: "Basketball",
  FOOTBALL: "Football",
  HOCKEY: "Hockey",
  SOCCER: "Soccer",
  MINOR_HOCKEY: "Minor Hockey",
  MBB: "Basketball",
  WBB: "Basketball",
  WVB: "Volleyball",
  GYMNASTICS: "Gymnastics",
  WGYM: "Gymnastics",
  WSOC: "Soccer",
  MINOR_BASKETBALL: "Basketball",
  WSB: "Softball",
  COLLEGE_BASEBALL: "Baseball",
  MSOC: "Soccer",
  MINOR_BASEBALL: "Baseball",
  MINOR_SOCCER: "Soccer",
  VOLLEYBALL: "Volleyball",
  WOMENS_BASKETBALL: "Basketball",
  LACROSSE: "Lacrosse",
  INDOOR_FOOTBALL: "Indoor Football",
};

export const isSportsEvent = (eventType: EventType) => {
  return SPORT_EVENT_TYPES[eventType] !== undefined;
};

export const eventTypeDisplay = (eventType: EventType) => {
  if (SPORT_EVENT_TYPES[eventType]) {
    return SPORT_EVENT_TYPES[eventType];
  }
  return eventType;
};
